import { GET_USER, GET_USERS_SUCCESS, GET_USERS_ERROR} from './actionTypes';

const initialState = {
    error: "",
    loadingGetUser: false,
    users: null,
    success: ""
}

const getUsers = (state = initialState, action) => {
    switch (action.type) {
        case GET_USER:
            state = {
                ...state,
                loadingGetUser: true
            }
            break;
        case GET_USERS_SUCCESS:
            state = {
                ...state,
                loadingGetUser: false,
                users: action.payload.users, 
                success: action.payload.message
            }
            break;
        case GET_USERS_ERROR:
            state = { ...state, error: action.payload, loadingGetUser: false };
            break;
        default:
            state = { ...state };
            break;
    }
    return state;
}

export default getUsers;